import React from 'react';

import { Link as NavLink } from '~/lib/react-router-dom';

import { Box, Link, Typography } from '@mui/material';

import currencyFormatter from '~/utils/currencyFormatter';

import { Credit } from '../Credits/types';

import { truncateOrderId } from './utils';

interface Props {
  credit: Credit;
}

function SingleCreditTransaction({ credit }: Props) {
  const amount = parseFloat(credit.amount);
  const formattedAmount = currencyFormatter(credit.currency, Math.abs(amount), 2);
  const isCredit = amount > 0;
  const isDebit = amount < 0;

  return (
    <Box>
      <Typography component="span" sx={{ fontWeight: 'bold' }}>
        {credit.credit_type}
      </Typography>
      {isCredit && (
        <Typography component="span" sx={{ ml: 1, color: 'success.main' }}>
          +{formattedAmount}
        </Typography>
      )}
      {isDebit && (
        <Typography component="span" sx={{ ml: 1, color: 'error.main' }}>
          -{formattedAmount}
        </Typography>
      )}
      {credit.comments && (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {credit.comments}
        </Typography>
      )}
      {credit.fk_orders && (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Order:{' '}
          <Link component={NavLink} to={`/purchases/${credit.fk_orders}`}>
            {truncateOrderId(credit.fk_orders)}
          </Link>
        </Typography>
      )}
      {credit.fk_added_by && (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Added by:{' '}
          <Link component={NavLink} to={`/users/${credit.fk_added_by}`}>
            {truncateOrderId(credit.fk_added_by)}
          </Link>
        </Typography>
      )}
    </Box>
  );
}

export { SingleCreditTransaction };
